import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'haw',
    fullName: 'Hawaiian',
    nativeName: 'ʻŌlelo Hawaiʻi',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Ke hele mai nei kekahi mea kupanaha",
    landing_subtitle: "ʻO ArgVoid kahi polokalamu hoʻomohala pāʻani. E hoʻomau, e hiki koke mai ana nā mea hou!",
    select_language: "E koho i ka ʻōlelo",
    search_placeholder: "Huli i nā ʻōlelo...",
    terms_title: "Kūlana o ka lawelawe",
    policy_title: "Kulekele pilikino",
    cookies_title: "Kuki Kuki",
    terms_content: `
        <strong>1. ʻAe ʻia i nā ʻŌlelo</strong><br>
        Ma ke komo ʻana iā ArgVoid, ʻae ʻia kēia mau ʻŌlelo o ka lawelawe. Inā ʻaʻole ʻae ʻia kēia mau ʻōlelo, ʻaʻole pono e hoʻohana ʻia ka lawelawe.<br><br>

        <strong>2. Ka hoʻohana ʻana i ke kahua </strong><br>
        Hāʻawi ʻia ʻo ArgVoid a me kāna mau noi "e like me" no ka ʻike a me nā kumu hana. Pono e hoʻohana ʻia ka lawelawe no nā kumu kūpono wale nō.<br><br>

        <strong>3. Hana ʻia i pāpā ʻia</strong><br>
        ʻAʻole ʻae ʻia ka hoʻohana ʻana i nā nāwaliwali o ka pūnaewele, spamming, a i ʻole ka hoʻāʻo ʻana i ka ʻae ʻole i ka ʻōnaehana.<br><br>

        <strong>4. Hōʻike hōʻike</strong><br>
        Hiki ke hoʻololi ʻia ka paepae a me nā lawelawe i kēlā me kēia manawa me ka ʻole o ka hoʻolaha. ʻAʻole hāʻawi ʻia kahi palapala hōʻoia e pili ana i ka uptime a i ʻole ka loaʻa ʻana o ka lawelawe.
    `,
    policy_content: `
        <strong>1. Ohi Ike</strong><br>
        ʻAʻole koi ka paepae i ka hōʻoia o ka mea hoʻohana a i ʻole ka hana moʻokāki i kēia manawa. ʻAʻohe ʻike pilikino (e like me nā inoa a i ʻole nā leka uila) i hōʻiliʻili ikaika ʻia mai nā malihini.<br><br>

        <strong>2. ʻIkepili hoʻohana</strong><br>
        Hiki ke hōʻiliʻili ʻia nā ʻikepili kumu, ʻike ʻole ʻia e hoʻomaopopo i ka hele ʻana o ka pūnaewele a hoʻomaikaʻi i nā noi. ʻAʻole pili kēia ʻikepili i ka ʻike kanaka hoʻohana.<br><br>

        <strong>3. Nā lawelawe ʻaoʻao ʻekolu</strong><br>
        Hiki ke hoʻohana ʻia nā mea hoʻolako ʻaoʻao ʻekolu no ka hoʻokipa a me nā lawelawe loiloi. Hoʻoponopono nā hana pilikino o kēia mau mea hoʻolako i ka ʻikepili inoa ʻole i hana ʻia ma kā lākou ʻoihana.<br><br>

        <strong>4. Palekana ʻikepili</strong><br>
        Hoʻokō ʻia nā hana palekana kūpono e pale i ka paepae. Eia naʻe, ʻaʻohe ala o ka hoʻouna ʻana ma luna o ka Pūnaewele i paʻa loa.<br><br>
    `,
    cookies_content: `
        <strong>1. He aha nā Kuki a me ka Waihona Kūloko?</strong><br>
        He mau waihona ʻikepili liʻiliʻi i mālama ʻia nā kuki a me ka mālama ʻana ma ka polokalamu no ka hoʻomanaʻo ʻana i nā koho hoʻonohonoho ma waena o nā kipa.<br><br>

        <strong>2. Manaʻo hoʻohana</strong><br>
        Hoʻohana ʻia ʻo Browser LocalStorage e mālama i nā hoʻonohonoho hoʻonohonoho, e like me:<br>
        - Nā makemake ʻōlelo<br>
        - Ka hoʻonohonoho ʻana o ka mea hoʻohana (e laʻa
        - Cache noi no ka manawa <br><br>

        <strong>3. ʻAʻohe Tracking</strong><br>
        ʻAʻole hoʻohana ʻia nā kuki a me ka waihona kūloko no ka hoʻolaha ʻana a i ʻole nā ​​manaʻo ʻimi ʻaoʻao ʻekolu. ʻO nā ʻikepili a pau i mālama ʻia no ka hana nui o ka paepae.<br><br>

        <strong>4. Mana</strong><br>
        Hiki ke hoʻomaʻemaʻe ʻia ka ʻikepili pūnaewele i kēlā me kēia manawa ma o nā hoʻonohonoho polokalamu kele pūnaewele, kahi e hoʻonohonoho hou ai i nā hoʻonohonoho kūloko.
    `,
    cookie_consent_text: "Hoʻohana mākou i nā kuki maʻamau e hōʻoia i ka hana pono o ka pūnaewele, e like me ka mālama ʻana i kāu kau, mālama i kāu makemake ʻōlelo, a me nā hoʻonohonoho maʻamau ʻē aʻe.",
    read_policy: "Heluhelu i ka Kuki Kuki",
    support_title: "Hoʻokaʻaʻike Kākoʻo",
    support_subject_label: "Kumuhana",
    support_message_label: "ʻŌlelo",
    support_submit_button: "Hoʻouna leka",
    support_hint: "Nānā: E wehe kēia i kāu palapala leka uila paʻamau e hoʻouna i ka leka.",
    support_success_msg: "Ke wehe nei i kāu polokalamu leka uila...",
    support_error_msg: "ʻAʻole i hoʻouna ʻia ka memo. E ʻoluʻolu e hoʻāʻo hou ma hope.",
    explorer_title: "Mea ʻimi",
    history_title: "Moolelo",
    animation_title: "Animation",
    config_title: "Hoʻonohonoho",
    tool_mouse: "Koho (Ctrl+M)",
    tool_brush: "Palaki (Ctrl+B)",
    tool_brush_mode: "ʻO ke ʻano hoʻololi (paʻa/māmā)",
    tool_eraser: "Holoi (Ctrl+E)",
    tool_brush_size: "Hoʻoponopono i ka nui o ka Brush",
    tool_bucket: "Hoʻopiha (Ctrl+F)",
    tool_eyedropper: "Pahu maka",
    tool_grid: "Māhele (Ctrl+Shift+B)",
    tool_rotate: "Hoʻololi (Ctrl+Shift+R)",
    tool_flip_h: "Huli H (Ctrl+Shift+H)",
    tool_flip_v: "Huli V (Ctrl+Shift+V)",
    tool_transpose: "Hoʻololi (Ctrl+Shift+T)",
    label_width: "Laulā",
    label_height: "kiʻekiʻe",
    label_frames: "Ka helu o na Papa",
    label_animation: "Kaila Animation",
    label_background_color: "Ka waihoʻoluʻu",
    label_interval: "Kūwaena",
    tool_anim_config: "Hoʻonohonoho hoʻolālā",
    label_new_width: "Laulā Hou",
    label_new_height: "Kiʻekiʻe Hou",
    label_apply: "E noi",
    label_colors: "Nā kala",
    label_size: "Nui",
    label_tolerance: "Hoʻomanawanui",
    val_horizontal: "Kaupae",
    val_vertical: "Kū pololei",
    val_sequence: "Kaʻina",
    val_bounce: "Bounce",
    val_random: "Hoʻokaʻawale",
    val_solid: "Paʻa",
    val_clear: "Akaka",
    action_add_sheet: "Pepa Hou",
    action_import: "Lawe mai",
    action_export: "Hoʻokuʻu aku",
    action_sort_projects: "Hoʻokaʻawale",
    sort_date_old: "Kahiko Mua",
    sort_date_new: "Mea Hou Mua",
    sort_name_az: "Ka inoa (A-Z)",
    sort_name_za: "Inoa (Z-A)",
    action_new_sprite: "Sprite Hou",
    action_new_project: "Papahana Hou",
    modal_save_all_title: "E mālama i nā hoʻololi a pau",
    modal_save_all_desc: "E koho i nā waiwai e mālama ai:",
    modal_save_selected: "Mālama i koho ʻia",
    action_saved: "Mālama ʻia",
    modal_create_sprite_title: "Hana hou Sprite",
    modal_create_project_title: "Hana i ka Papahana Hou",
    modal_add_sheet_title: "Hoʻohui i ka Pepa Hou",
    modal_rename_sheet_title: "Ka inoa hou i ka Pepa",
    modal_rename_sprite_title: "Kapa inoa hou iā Sprite",
    modal_delete_sprite_title: "Holoi iā Sprite",
    modal_delete_project_title: "Holoi Papahana",
    modal_delete_sheet_title: "Holoi Pepa",
    placeholder_sprite_name: "inoa",
    placeholder_project_name: "inoa",
    placeholder_sheet_name: "inoa",
    placeholder_new_name: "Inoa Hou",
    action_create: "Hana",
    action_add: "Hoʻohui",
    action_rename: "inoa hou",
    action_duplicate: "Kalua",
    action_delete: "Holoi",
    action_cancel: "Hoʻopau",
    confirm_delete_sprite: "Makemake ʻoe e holoi i kēia sprite?",
    confirm_delete_project: "Makemake ʻoe e holoi i kēia pāhana? E wehe ʻia nā sprite a pau.",
    confirm_delete_sheet: "Makemake ʻoe e holoi i kēia pepa?",
    err_select_sprite: "E koho mua i kahi sprite.",
    err_select_project: "E koho mua i kahi papahana.",
    err_name_empty: "ʻAʻole hiki ke nele ka inoa.",
    err_sprite_exists: "Aia kekahi sprite me kēlā inoa.",
    err_project_exists: "Aia kekahi papahana me kēlā inoa.",
    err_no_content: "ʻAʻohe mea e mālama ai.",
    err_no_changes: "ʻAʻohe hoʻololi e mālama.",
    err_delete_last_sheet: "ʻAʻole hiki ke holoi i ka pepa hope loa.",
    err_extract_frames: "ʻAʻole hiki ke unuhi i nā kiʻi.",
    err_indexeddb: "ʻAʻole i mālama ʻia ma ka ʻāina. ʻAʻole kākoʻo paha kāu polokalamu kele pūnaewele iā IndexedDB.",
    msg_upload_success: "Pōmaikaʻi ka hoʻouka ʻana: {0}",
    msg_upload_failed: "Hāʻule ka hoʻouka ʻana: {0}",
    msg_save_success: "Mālama maikaʻi.",
    msg_saving: "Mālama ʻia...",
    msg_multi_save_result: "Mālama ʻia {0} waiwai. {1} hāʻule.",
    menu_title: "Menu",
    menu_save: "Mālama",
    menu_save_all: "Mālama i nā mea a pau",
    menu_support: "Hoʻokaʻaʻike Kākoʻo",
    label_local_storage: "Waihona kūloko",
    label_sign_in: "ʻeʻe",
    modal_export_title: "Hoʻokuʻu aku iā Sprite",
    label_filename: "inoa faila",
    label_format: "Hōʻano",
    action_export_confirm: "Hoʻokuʻu aku",
};

export default translations;
